import React from "react";
import { Marker, Popup } from "react-leaflet";
import { camp } from "../Icons/icons";
import shelterData from "../data/shelters.json";

const labels = {
  description: {
    da: "Beskrivelse",
    en: "Description",
    de: "Beschreibung",
  },
  seeMore: {
    da: "Se flere overnatningssteder",
    en: "See more accommodations",
    de: "Weitere Unterkünfte anzeigen",
  },
};

/*
 * This component displays the shelter markers on the map
 */

const Shelters = (props) => {
  const campMakers = shelterData.map((x, i) => (
    <Marker
      key={i}
      position={x.position}
      toolTip={`Overnatning ${x.name}`}
      icon={camp}
      zIndexOffset={1}
    >
      <Popup>
        <p>
          <b>{labels.description[props.language]}</b>
        </p>
        <p dangerouslySetInnerHTML={{ __html: x.longdescription }} />
        <a
          href="http://udinaturen.dk"
          target="_blank"
          rel="noopener noreferrer"
        >
          {labels.seeMore[props.language]}
        </a>
      </Popup>
    </Marker>
  ));
  return <div>{campMakers}</div>;
};

export default Shelters;
